export default __webpack_public_path__ + "static/media/cv151-5.286257bd.png";